module.exports = __webpack_public_path__ + "static/media/Home Page_website-30.1087a288.png";